var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"closeapp-logo"},[_c('v-img',{attrs:{"max-width":"300","width":"","src":"/assets/Closeapp-logo.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }